import React from "react";
import Typography from "@material-ui/core/Typography";

import { StyledGrid } from "components/simple";
import { color, spacingDefaults, fontSize } from "style/constants";
import { ReactComponent as NoteIcon } from "assets/note.svg";

interface TotalScoreHeaderProps {
  status: string;
  score: number | null;
  readyToFinalize?: boolean;
  generalNote: number;
}

const TotalScoreHeader: React.FC<TotalScoreHeaderProps> = ({
  status,
  score,
  readyToFinalize,
  generalNote
}: TotalScoreHeaderProps) => (
  <StyledGrid
    container
    padding={`${spacingDefaults.normal} ${spacingDefaults.large}`}
    direction="row"
    justifyContent="space-between"
    alignItems="center"
  >
    <StyledGrid item>
      <Typography variant="h6" component="h2">
        <strong>Total BHI Score</strong>
      </Typography>
    </StyledGrid>
    {generalNote && (
      <StyledGrid
        alignItems="center"
        aria-label={`general-note-count`}
        container
        fontSize={fontSize.small}
        item
        itemMargin="0.1rem"
        marginLeft={spacingDefaults.large}
        xs
      >
        <NoteIcon height="18px" width="18px" stroke={color.BLACK} />
        {generalNote}
      </StyledGrid>
    )}
    <StyledGrid item>
      <StyledGrid
        container
        direction="row"
        alignItems="center"
        paddingRight={spacingDefaults.xlarge}
      >
        <StyledGrid marginRight={spacingDefaults.normal} hidden={status === "score_finalized"}>
          <Typography variant="body1" color="textSecondary">
            {!readyToFinalize && (
              <i>There are remaining assessments to score before this score is final</i>
            )}
          </Typography>
        </StyledGrid>
        <StyledGrid fontSize={fontSize.large}>
          <strong>{score}</strong>
        </StyledGrid>
      </StyledGrid>
    </StyledGrid>
  </StyledGrid>
);

export default TotalScoreHeader;
